import React, { useState } from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
type PlanKey = 'basico' | 'completo';
const PLANS: {
  key: PlanKey;
  emoji: string;
  name: string;
  subtitle: string;
  items: string[];
  extraItems?: string[];
  oldPrice: string;
  price: string;
  checkoutUrl: string;
  badge?: string;
  saveBadge?: string;
  isVip?: boolean;
}[] = [{
  key: 'basico',
  emoji: '📘',
  name: 'PACK BÁSICO',
  subtitle: '4 libros + 400 citas + bonos',
  items: ['📘 100 Citas Mamá e Hija', '📗 100 Citas Mamá e Hijo', '📙 100 Citas Papá e Hija', '📕 100 Citas Papá e Hijo'],
  oldPrice: '$33.990',
  price: '$19.990',
  checkoutUrl: 'https://tiempodefamilia.com/cart/51018977378610:1'
}, {
  key: 'completo',
  emoji: '🏆',
  name: 'PACK COMPLETO',
  subtitle: '6 libros + 600 citas + bonos',
  items: ['📘 100 Citas Mamá e Hija', '📗 100 Citas Mamá e Hijo', '📙 100 Citas Papá e Hija', '📕 100 Citas Papá e Hijo'],
  extraItems: ['+ 💑 100 Citas en Pareja', '+ 👨‍👩‍👧 100 Citas en Familia'],
  oldPrice: '$59.990',
  price: '$27.990',
  checkoutUrl: 'https://tiempodefamilia.com/cart/51018985701682:1',
  badge: '⭐ Más elegido',
  saveBadge: 'Mejor valor',
  isVip: true
}];
export function PricingSection() {
  const [selected, setSelected] = useState<PlanKey>('completo');
  const currentPlan = PLANS.find(p => p.key === selected)!;
  const fadeIn = useFadeIn();
  return <section id="pricing" className="py-20 px-4 bg-[#111111] scroll-mt-10" data-id="element-113">
      <div className="max-w-3xl mx-auto" data-id="element-114">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-115">
          <div className="text-center mb-10" data-id="element-116">
            <p className="text-xl md:text-2xl font-black text-yellow-400 mb-2 uppercase tracking-wide" data-id="element-117">
              🎉 OFERTA POR TIEMPO LIMITADO
            </p>
            <h2 className="text-3xl md:text-5xl font-black text-white mb-6 leading-tight" data-id="element-118">
              ✅ Estás a un paso de acceder al Pack 100 Citas Familiares
            </h2>
            <p className="text-lg text-gray-300 font-medium mb-8 max-w-2xl mx-auto" data-id="element-119">
              Un conjunto único de libros digitales diseñados para fortalecer la
              conexión con tus hijos, pareja y toda tu familia.
            </p>

            <div className="bg-gray-900 border border-gray-800 p-6 rounded-xl text-left mb-8" data-id="element-120">
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-121">
                🎁 Te llevás todo esto dentro del Pack 100 Citas Familiares
              </h3>

              <p className="text-yellow-400 font-bold mb-3" data-id="element-122">
                4 Libros Digitales llenos de actividades, juegos y momentos
                únicos:
              </p>
              <ul className="space-y-2 text-gray-300 mb-6 ml-2" data-id="element-123">
                <li data-id="element-124">📘 100 Citas con mi Hija (versión mamá e hija)</li>
                <li data-id="element-125">📗 100 Citas con mi Hijo (versión mamá e hijo)</li>
                <li data-id="element-126">📙 100 Citas con mi Hija (versión papá e hija)</li>
                <li data-id="element-127">📕 100 Citas con mi Hijo (versión papá e hijo)</li>
              </ul>

              <p className="text-yellow-400 font-bold mb-3" data-id="element-128">
                ✨ Cada libro incluye:
              </p>
              <ul className="space-y-2 text-gray-300 mb-6 ml-2" data-id="element-129">
                <li className="flex items-start gap-2" data-id="element-130">
                  <span className="text-yellow-400" data-id="element-131">✨</span>
                  <span data-id="element-132">
                    Actividades y desafíos familiares simples, económicos y
                    divertidos
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-133">
                  <span className="text-yellow-400" data-id="element-134">✨</span>
                  <span data-id="element-135">
                    Momentos guiados para fortalecer la conexión emocional
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-136">
                  <span className="text-yellow-400" data-id="element-137">✨</span>
                  <span data-id="element-138">
                    Ideas para desconectarse de las pantallas y reconectarse
                    entre ustedes
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-139">
                  <span className="text-yellow-400" data-id="element-140">✨</span>
                  <span data-id="element-141">
                    Espacios para escribir, reflexionar y guardar recuerdos
                  </span>
                </li>
              </ul>

              <p className="text-yellow-400 font-bold mb-3" data-id="element-142">
                🎁 Además, te llevás 7 bonos exclusivos:
              </p>
              <ul className="space-y-2 text-gray-300 ml-2" data-id="element-143">
                <li data-id="element-144">
                  💌 Recuerdos para mi hija – 30 mensajes y reflexiones que ella
                  recordará toda la vida
                </li>
                <li data-id="element-145">
                  🎲 Adiós al aburrimiento – 52 planes económicos y entretenidos
                  para disfrutar todo el año
                </li>
                <li data-id="element-146">
                  🔑 Juegos secretos – Actividades que revelan lo que tus hijos
                  realmente piensan y sienten
                </li>
                <li data-id="element-147">
                  👵 Abuelita, cuéntame tu historia – Un viaje emocional por sus
                  recuerdos
                </li>
                <li data-id="element-148">
                  👴 Abuelito, cuéntame tu historia – Un legado familiar lleno
                  de anécdotas
                </li>
                <li data-id="element-149">
                  👩‍👧 Mamá, cuéntame tu historia – Un espacio íntimo para
                  compartir experiencias
                </li>
                <li data-id="element-150">
                  👨‍👦 Papá, cuéntame tu historia – Momentos de conexión profunda
                  entre padre e hijo
                </li>
              </ul>
            </div>

            <p className="text-white font-bold text-base md:text-lg mt-4 animate-bounce" data-id="element-151">
              👇 Elegí tu plan y dale a COMPRAR AHORA 👇
            </p>
          </div>

          <div className="space-y-3 mb-8" data-id="element-152">
            {PLANS.map(plan => {
            const isSelected = selected === plan.key;
            const isVip = plan.isVip;
            return <button key={plan.key} onClick={() => setSelected(plan.key)} className={`w-full rounded-2xl p-4 md:p-5 flex items-start gap-3 md:gap-4 transition-all duration-300 cursor-pointer text-left relative overflow-hidden ${isSelected ? isVip ? 'bg-gradient-to-br from-[#1a1a00] via-[#1a1500] to-[#1a1a00] border-2 border-yellow-400 shadow-[0_0_40px_rgba(250,204,21,0.25)]' : 'bg-[#1a1a1a] border-2 border-gray-500' : 'bg-[#1a1a1a] border-2 border-[#2a2a2a] opacity-60 hover:opacity-85'}`} data-id="element-153">
                  {isVip && isSelected && <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-yellow-600 via-yellow-300 to-yellow-600" data-id="element-154"></div>}
                  <div className={`w-5 h-5 mt-1 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${isSelected ? isVip ? 'border-yellow-400' : 'border-white' : 'border-gray-600'}`} data-id="element-155">
                    {isSelected && <div className={`w-2.5 h-2.5 rounded-full ${isVip ? 'bg-yellow-400' : 'bg-white'}`} data-id="element-156" />}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-157">
                    <div className="flex items-center gap-2 mb-1 flex-wrap" data-id="element-158">
                      <span className="text-lg" data-id="element-159">{plan.emoji}</span>
                      <h3 className={`text-base md:text-lg font-black uppercase tracking-wide ${isVip ? 'text-yellow-400' : 'text-white'}`} data-id="element-160">
                        {plan.name}
                      </h3>
                    </div>
                    {(plan.badge || plan.saveBadge) && <div className="flex flex-wrap items-center gap-1.5 mb-1.5" data-id="element-161">
                        {plan.badge && <span className="inline-flex items-center gap-1 bg-gradient-to-r from-yellow-500 via-amber-400 to-yellow-500 text-black text-[10px] md:text-xs font-black px-2 py-0.5 rounded-full uppercase tracking-wider shadow-md" data-id="element-162">
                            {plan.badge}
                          </span>}
                        {plan.saveBadge && <span className="inline-flex items-center text-yellow-400 text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full border border-yellow-400/50 uppercase tracking-wider bg-yellow-400/10" data-id="element-163">
                            {plan.saveBadge}
                          </span>}
                      </div>}
                    <p className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-164">
                      {plan.subtitle}
                    </p>
                    {isSelected && <div className="flex flex-col gap-0.5 mt-2" data-id="element-165">
                        {plan.items.map((item, i) => <p key={i} className="text-[11px] md:text-xs text-gray-400" data-id="element-166">
                            {item}
                          </p>)}
                        {plan.extraItems?.map((item, i) => <p key={`extra-${i}`} className={`text-xs md:text-sm font-bold ${isVip ? 'text-yellow-300' : 'text-blue-300'}`} data-id="element-167">
                            {item}
                          </p>)}
                      </div>}
                  </div>
                  <div className="text-right flex-shrink-0 pt-0.5" data-id="element-168">
                    <p className="text-[11px] md:text-sm text-gray-500 line-through font-medium" data-id="element-169">
                      {plan.oldPrice}
                    </p>
                    <p className={`text-2xl md:text-3xl font-black ${isVip && isSelected ? 'text-yellow-400' : 'text-white'}`} data-id="element-170">
                      {plan.price}
                    </p>
                  </div>
                </button>;
          })}
          </div>

          <p className="text-center text-sm md:text-base text-gray-300 italic mb-6" data-id="element-171">
            🔥 El 80% de nuestros clientes elige el Pack Completo. Es el que más
            valor tiene por su precio.
          </p>

          <a href={currentPlan.checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-172">
            <div className="relative w-full group cta-pulse" data-id="element-173">
              <div className="absolute -inset-1 bg-gradient-to-r from-red-600 to-orange-500 rounded-xl opacity-70 md:group-hover:opacity-100 transition duration-200" data-id="element-174"></div>
              <div className="relative w-full flex flex-col items-center justify-center px-6 py-4 bg-gradient-to-b from-red-500 to-red-700 border-b-4 border-red-900 rounded-xl shadow-2xl text-white font-black text-xl md:text-2xl uppercase tracking-wide md:hover:from-red-400 md:hover:to-red-600 transition-all" data-id="element-175">
                <div className="flex items-center gap-2 text-center" data-id="element-176">
                  👉 COMPRAR AHORA
                </div>
                <span className="text-sm md:text-base font-medium text-red-100 mt-1 normal-case tracking-normal" data-id="element-177">
                  Descarga inmediata • Garantía de 7 días
                </span>
              </div>
            </div>
          </a>

          <div className="flex items-center justify-center gap-4 mt-6 text-gray-500 text-sm" data-id="element-178">
            <span className="flex items-center gap-1" data-id="element-179">🔒 Pago seguro</span>
            <span data-id="element-180">•</span>
            <span className="flex items-center gap-1" data-id="element-181">
              📥 Descarga inmediata
            </span>
            <span data-id="element-182">•</span>
            <span className="flex items-center gap-1" data-id="element-183">✅ Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}